import { Gauge } from "lucide-react";

export default function ProductionGuarantee() {
  return (
    <section className="py-20 md:py-28 bg-[#0F382C] text-[#F8FAFC]" data-testid="production-guarantee-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <div className="eyebrow" style={{ color: "#FEF3C7" }}>Production Guarantee</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl font-semibold">
            What if my system doesn't produce as expected?
          </h2>
          <p className="mt-5 text-lg text-[#F8FAFC]/80 max-w-xl">
            You're purchasing the <em>production</em> — not the panels. Eligible shortfalls may receive compensation according to your signed agreement.
          </p>

          <div className="mt-8 inline-flex items-center gap-3 rounded-2xl bg-[#D97706] text-[#FDFBF7] px-5 py-4" data-testid="production-guarantee-refund-callout">
            <Gauge className="w-5 h-5 shrink-0" />
            <div>
              <div className="font-serif-display text-xl leading-tight">We refund the difference.</div>
              <div className="text-xs text-[#FEF3C7]/90 mt-0.5">When qualifying production falls short of the guarantee, the shortfall is compensated per your signed agreement.</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="rounded-3xl bg-white/5 border border-white/10 p-8">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-xl bg-[#D97706] flex items-center justify-center">
                <Gauge className="w-5 h-5 text-[#FDFBF7]" />
              </div>
              <div className="font-mono-metric text-xs uppercase tracking-widest text-[#FEF3C7]">Example Year</div>
            </div>
            <div className="mt-6 space-y-4">
              <div className="flex justify-between items-baseline">
                <span className="text-sm text-[#F8FAFC]/75">Promised production</span>
                <span className="font-mono-metric text-2xl">10,000 kWh</span>
              </div>
              <div className="h-2 rounded-full bg-white/10">
                <div className="h-2 rounded-full bg-[#FEF3C7]" style={{ width: "100%" }} />
              </div>
              <div className="flex justify-between items-baseline">
                <span className="text-sm text-[#F8FAFC]/75">Actual qualifying production</span>
                <span className="font-mono-metric text-2xl">8,000 kWh</span>
              </div>
              <div className="h-2 rounded-full bg-white/10">
                <div className="h-2 rounded-full bg-[#D97706]" style={{ width: "80%" }} />
              </div>
              <div className="pt-4 border-t border-white/10 flex justify-between items-baseline">
                <span className="text-sm text-[#F8FAFC]/75">Difference evaluated under guarantee</span>
                <span className="font-mono-metric text-xl text-[#FEF3C7]">2,000 kWh</span>
              </div>
            </div>
          </div>
          <div className="mt-4 text-center">
            <div className="inline-block badge-pill" style={{ background: "rgba(217,119,6,0.15)", color: "#FEF3C7" }}>25-Year Production Guarantee</div>
          </div>
        </div>
      </div>
    </section>
  );
}
